export const landingSetup = () => {
    return {
        title: 'Configuración del contratista',
        subtitle: 'Después de crear su cuenta, puede regresar en cualquier momento para terminar de configurar su empresa.'
    }
}
